
import React from 'react';
import firebase from 'firebase';



const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);

var status = firestore.collection("systemStatus").doc("status");



export default class RisFeed extends React.Component {
    state = {
        risStatus : "",
        risLastupdated : "",
    }


    getDoc = status.get()
        .then(doc => {
            if (!doc.exists) {
                console.log('No status document!');
            } else {
                console.log('Document data:', doc.data());
                this.setState({risStatus : doc.data().risfeed})
                this.setState({risLastupdated :  doc.data().risepoch})
            }
        })
        .catch(err => {
            console.log('Error getting document', err);
        });

    render(){
        return (
            <div>
            <p>RIS Status: {this.state.risStatus} . Last checked : {this.state.risLastupdated} </p>      
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Component/RisFeed.js